import {
  handleGetDevice,
  handleGetAllDevices,
  handleUpdateDevice,
  handleUploadFirmware,
  handleDeleteFirmware,
} from "@/api/deviceAPI";

export default {
  state: {
    docs: null,
    device: null,
    devices: [],
  },

  mutations: {
    setDevice(state, payload) {
      state.device = payload;
    },

    setDevices(state, payload) {
      state.devices = payload;
    },
  },

  actions: {
    async fetchDevice({ commit }, payload) {
      try {
        await handleGetDevice(payload, (res) => {
          commit("setDevice", res);
        });
      } catch (err) {
        console.log(err);
      }
    },

    async fetchAllDevices({ commit }) {
      commit("setDataLoading", true);
      try {
        await handleGetAllDevices((res) => {
          commit("setDevices", res);
          commit("setDataLoading", false);
        });
      } catch (err) {
        console.log(err);
        commit("setDataLoading", false);
      }
    },

    async updateDevice({ commit, dispatch }, payload) {
      commit("setBtnLoading", true);
      try {
        await handleUpdateDevice(payload);
        dispatch("fetchAllDevices");
        commit("setBtnLoading", false);
      } catch (err) {
        commit("setBtnLoading", false);
      }
    },

    async uploadFirmware({ commit }, payload) {
      commit("setDataLoading", true);
      try {
        await handleUploadFirmware(payload);
        commit("setDataLoading", false);
        // commit("setStatus", "File uploaded successfully!");
      } catch (err) {
        commit("setDataLoading", false);
        console.error("Error uploading file: ", err);
      }
    },

    async deleteFirmware({ commit }, payload) {
      commit("setDataLoading", true);
      try {
        await handleDeleteFirmware(payload);
        commit("setBtnLoading", false);
        commit("setStatus", "File uploaded successfully!");
      } catch (err) {
        commit("setBtnLoading", false);
        console.error("Error uploading file: ", err);
      }
    },
  },

  getters: {},
};
